import { render, staticRenderFns } from "./singleGig.vue?vue&type=template&id=e6399aea&scoped=true&"
import script from "./singleGig.vue?vue&type=script&lang=js&"
export * from "./singleGig.vue?vue&type=script&lang=js&"
import style0 from "./singleGig.vue?vue&type=style&index=0&id=e6399aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6399aea",
  null
  
)

export default component.exports